export default __webpack_public_path__ + "static/media/Ballroll_00113.685b3c95.png";